import { setStotageUserData, getStotageUserData } from '@/hooks/useRecordOperation/store'

export const FREIGHT_UNIFIED_KEY = 'UNIFIED'
export const FREIGHT_CHANNEL_KEY = 'CHANNEL'
export const FREIGHT_SEPARATE_KEY = 'SEPARATE'

export const editValueMap = {
    [FREIGHT_UNIFIED_KEY]: 0,
    [FREIGHT_CHANNEL_KEY]: 2,
    [FREIGHT_SEPARATE_KEY]: 1
}

export const FREIGHT_TEMPLATE_LIST = [
    {
        key: FREIGHT_UNIFIED_KEY,
        name: '所有分销商都使用一套运费模板',
        desc: '全国包邮/所有分销商收相同的运费'
    },
    {
        key: FREIGHT_CHANNEL_KEY,
        name: '按分销商设置运费模板',
        desc: '某些分销大客，想在运费上有优惠；分销商主做的平台/地区不同，运费标准不一，可按分销商单独设运费'
    },
    {
        key: FREIGHT_SEPARATE_KEY,
        name: '按发货仓设置运费模板',
        desc: '多地有发货仓库，运费不一样，可按发货仓设置运费'
    }
]

export const findFreightName = type => {
    const item = FREIGHT_TEMPLATE_LIST.find(item => item.key === type)

    return item ? item.name : ''
}

// 复制分销运费模版传给后端的枚举
export const FREIGHT_MAP = {
    [FREIGHT_UNIFIED_KEY]: 'Default',
    [FREIGHT_CHANNEL_KEY]: 'DrpLevel',
    [FREIGHT_SEPARATE_KEY]: 'Warehouse'
}
